import {
    savePipedriveIntegration,
    getPipedriveState,
    getPipedriveData,
} from './pipedrive.state';

import { integrationHookFactory } from '../integrations.hooks';

export const usePipedrive = integrationHookFactory({
    saveAction: savePipedriveIntegration,
    loadAction: getPipedriveData,
    stateSelector: getPipedriveState,
});
